import { jsx } from "react/jsx-runtime";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import { validateTidalLicense } from "../../base/index.js";
function FormatBold(props) {
  return /* @__PURE__ */ jsx(
    FormatBoldIcon,
    {
      "data-testid": "FormatBold",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatBold",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatBold.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatBold"
};
validateTidalLicense();
export {
  FormatBold
};
//# sourceMappingURL=FormatBold.js.map
